import { Pagination, PaginationProps } from '@mantine/core';

/**
 * AfaPagination - Componente de paginación con estilo AFA
 * 
 * Wrapper del componente Pagination de Mantine con color "brand" por defecto.
 * Ideal para tablas con muchos registros que necesitan dividirse en páginas.
 * 
 * @example
 * // Uso básico
 * <AfaPagination total={10} />
 * 
 * @example
 * // Con estado controlado
 * <AfaPagination 
 *   total={totalPages} 
 *   value={currentPage}
 *   onChange={setCurrentPage}
 * />
 * 
 * @example
 * // Con configuración personalizada
 * <AfaPagination 
 *   total={20}
 *   siblings={2}
 *   boundaries={2}
 *   withEdges
 * />
 */
export type AfaPaginationProps = PaginationProps;

export const AfaPagination = (props: AfaPaginationProps) => {
  return (
    <Pagination 
      color="brand" 
      size="md"
      {...props} 
    />
  );
};
